import { SshAccountActions } from "@dots-crm/contracts/client";

export const SSH_ACCOUNT_ENDPOINTS_URLS = {
  create: "ssh-account",
  readMany: "ssh-account",
  delete: ({ sshAccountId }: SshAccountActions["delete"]["params"]) =>
    `ssh-account/${sshAccountId}`,
  import: "ssh-account/import",
  importTemplate: "ssh-account/import/template",
  export: "ssh-account/export",
};

export const SSH_ACCOUNT_TAGS = {
  sshAccount: "sshAccount",
};
